import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerServiceWorker, recoverPoisonedShellOnce } from './registerServiceWorker';

/**
 * Domain Redirect: Netlify → spenderly.in
 */
if (window.location.hostname === 'spenderly.netlify.app' || window.location.hostname === 'spenderly.netlify.com') {
  window.location.replace('https://spenderly.in' + window.location.pathname + window.location.search);
}

recoverPoisonedShellOnce();

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {googleClientId ? (
      <GoogleOAuthProvider clientId={googleClientId}>
        <App />
      </GoogleOAuthProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>
);

registerServiceWorker();
reportWebVitals();
